import s3Storage from '@happylife-a/s3-storage';
import { buildBinaryFile } from '../../../../helpers';
import { buildQueryVariables } from '../../../helpers';

/**
 * Category UseCase for V2 API
 * @param {{
 *   CategoryServiceV2: ReturnType<import('../../../services/v2/CategoryServiceV2').default>,
 *   AwsS3Service: ReturnType<import('../../../services/AwsS3Service').default>,
 * }} param0
 */
export default function categoryUseCaseV2({ CategoryServiceV2, AwsS3Service }) {
  const getAllCategories = () => CategoryServiceV2.getAllCategories();

  const getCategories = (params) => {
    const serviceParams = buildQueryVariables({
      parentId: params?.parentId ?? 'null',
      limit: params?.limit,
      offset: params?.offset,
      orderBy: params?.orderBy,
    });

    if (params?.search) {
      serviceParams.search = params.search;
    }

    return CategoryServiceV2.getCategories(serviceParams);
  };

  const getCategoryById = (id) => CategoryServiceV2.getCategoryById(id);

  const createCategory = (input) => CategoryServiceV2.createCategory(input);

  const updateCategory = (categoryId, input) => {
    return CategoryServiceV2.updateCategory(categoryId, input);
  };

  const deleteCategory = (categoryId) => CategoryServiceV2.deleteCategory(categoryId);

  const reorderCategories = (data) => CategoryServiceV2.reorderCategories(data);

  const uploadImage = async (file) => {
    const folder = s3Storage.configs.folders.FOLDER_CATEGORY_IMAGE;
    const { binary, extension } = await buildBinaryFile(file);

    return AwsS3Service.uploadPublic(binary, {
      folder: folder,
      extension: extension,
    });
  };

  const uploadIcon = async (file) => {
    const folder = s3Storage.configs.folders.FOLDER_CATEGORY_ICON;
    const { binary, extension } = await buildBinaryFile(file);

    return AwsS3Service.uploadPublic(binary, {
      folder: folder,
      extension: extension,
    });
  };

  return {
    getAllCategories,
    getCategories,
    getCategoryById,
    createCategory,
    updateCategory,
    deleteCategory,
    reorderCategories,
    uploadImage,
    uploadIcon,
  };
}
